import React, { useState } from 'react';
import CrudGrid from '../../components/CrudGrid';
import { fetchData, deleteData, saveData } from '../../components/ParentComponent';
import { useAuth } from '../../hooks/useAuth';
import { GridColDef } from '@mui/x-data-grid';
import ErrorPopup from '../../error/ErrorPopup'; // Import the ErrorPopup component

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'price', headerName: '价格', width: 230, editable: true }
];

const PricePage: React.FC = () => {
  const { user } = useAuth();
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const handleError = (error: string) => {
    setErrorMessage(error);
    setShowErrorPopup(true);
  };

  return (
    <div>
      {showErrorPopup && <ErrorPopup message={errorMessage} onClose={() => setShowErrorPopup(false)} />}
      <CrudGrid
        userRole={user?.role || 'guest'}
        fetchData={() => fetchData(null, '/get_membership_prices', handleError)}
        deleteData={(id) => deleteData(id, '/delete_membership_price', handleError)}
        saveData={(TableRow) => saveData(TableRow, '/create_membership_price', '/update_membership_price', handleError)}
        columns={columns}
        title="价格"
      />
    </div>
  );
};

export default PricePage;
